
if (!customElements.get("zoom-image")) {
  customElements.define(
    "zoom-image",
    class extends HTMLElement {
      constructor() {
        super();

        this.x = 0.5;
        this.y = 0.5;

        this.section = this.closest(".shopify-section");
        this.slideIndex = this.dataset.index;
        this.sectionId = this.dataset.section;

        this.button = this.querySelector("[data-zoom-button]");
        this.loadingSpinner = this.querySelector(".spinner"); 

        this.productMediaContent = this.section?.querySelector("[data-product-media-content]");

        this.zoomTypeEl = document.querySelector("[data-desktop-zoom-type]");

        this.template = this.productMediaContent?.querySelector("template") || null;

        this.overlay = null;
        this.isHovering = false;

        if (!this.button) return;

        this.button.addEventListener("click", (event) => this.handleClick(event));
      }

      
      /* ------------------------------
       * CLICK HANDLER (Customizer safe)
       * ------------------------------ */
      handleClick(event) {
        const rect = event.currentTarget.getBoundingClientRect();
        this.x = (event.clientX - rect.left) / rect.width;
        this.y = (event.clientY - rect.top) / rect.height;

        const zoomType = this.zoomTypeEl?.dataset.desktopZoomType;


        const showInline = zoomType === "innerzoom" && window.matchMedia("(min-width: 992px)").matches;

        if (showInline) {
          const isKeyboard =
            document.documentElement.getAttribute("data-what-intent") === "keyboard";

          if (
            !isKeyboard &&
            event.pointerType === "mouse" &&
            (event.clientX > 0 || event.clientY > 0)
          ) {
            this.activateHoverZoom();
          } else {
            this.openZoomModal();
          }
        } else {
          this.openMediaPopup();
        }
      }

      /* ------------------------------
       * INNER / HOVER ZOOM
       * ------------------------------ */
      activateHoverZoom() {
        this.isHovering = true;

        if (this.overlay) {
          this.overlay.classList.remove("hidden");
          return;
        }

        this.loadingSpinner?.classList.remove("hidden");

        const picture = this.querySelector("picture");
        const image = this.querySelector("img");
        if (!image || !picture) return;

        picture.style.opacity = "0.5";

        const overlay = document.createElement("div");
        overlay.className = "zoom__zoom-image";
        overlay.setAttribute("aria-hidden", "true");
        overlay.style.backgroundImage = `url('${image.src}')`;

        overlay.addEventListener("mousemove", (e) =>
          this.hoverMove(image, overlay, e)
        );

        overlay.addEventListener("click", () => this.hideHoverZoom());

        overlay.addEventListener("mouseleave", () => {
          this.isHovering = false;
          setTimeout(() => {
            if (!this.isHovering) this.hideHoverZoom();
          }, 100);
        });

        this.overlay = overlay;

        const preload = new Image();
        preload.src = image.src;

        preload.onload = () => {
          this.loadingSpinner?.classList.add("hidden");
          picture.after(overlay);
          picture.style.opacity = "1";
        };
      }

      hideHoverZoom() {
        this.isHovering = false;
        this.overlay?.classList.add("hidden");
      }

      hoverMove(image, overlay, event) {
        this.isHovering = true;

        const zoomRatio = 2;
        const rect = overlay.getBoundingClientRect();

        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
        overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
      }

      /* ------------------------------
       * MODAL / POPUP
       * ------------------------------ */
      openZoomModal() {
        this.openMediaPopup();
      }

      openMediaPopup() {
        if (!this.template) return;

        if (document.querySelector(`#product-media-content-${this.sectionId}`))
          return;

        const content = this.template.content.firstElementChild.cloneNode(true);
        document.body.appendChild(content);

        const popup = document.querySelector(
          `#product-media-content-${this.sectionId}`
        );

        const slideshow = popup?.querySelector('slideshow-swiper');

        if (!slideshow) return;
        const waitForSwiper = setInterval(() => {
          if (slideshow.slider) {
            clearInterval(waitForSwiper);

            slideshow.slider.update();
            slideshow.slider.slideTo(Number(this.slideIndex - 1), 300);
          }
        }, 100);
        if (popup) {
          setTimeout(() => popup.setAttribute("open", ""), 200);
        }
      }
    }
  );
}

if (!customElements.get("product-media-dialog")) {
class ProductMediadialog extends HTMLElement {
  constructor() {
    super(),
      (this.closeBtn = this.querySelector("[data-modal-close]")),
      this.closeBtn && this.closeBtn.addEventListener("click", this.closeMediaPopup.bind(this));
  }
  closeMediaPopup() {
    this.removeAttribute('open');
    setTimeout(
      function () {
        this.remove();
      }.bind(this),
      500
    );

  }
}
customElements.define("product-media-dialog", ProductMediadialog);
}